import React from 'react'
import Link from 'gatsby-link'
import Img from 'gatsby-image'
import Palette from 'react-palette'
import styles from './ProjectListing.module.scss'

export default class ProjectListing extends React.PureComponent {
	getList() {
		const List = []
		this.props.projectEdges.forEach(projectEdge => {
			List.push({
				path: projectEdge.node.fields.slug,
				coverImage: projectEdge.node.frontmatter.coverImage.childImageSharp.sizes,
				client: projectEdge.node.frontmatter.client,
				title: projectEdge.node.frontmatter.title,
				service: projectEdge.node.frontmatter.service,
				imageURL: projectEdge.node.frontmatter.coverImage.childImageSharp.sizes.src,
			})
		})
		return List
	}
	render() {
		const List = this.getList()
		return (
			<div className={styles.base}>
				{List.map(project => (
					<div key={project.path} className={styles.wrapper}>
						<div className={styles.content}>
							<div className={styles.image}>
								<Img sizes={project.coverImage} />
							</div>
							<Link
								to={project.path}
								key={project.path}
								className={styles.link}
							>
								<Palette image={project.imageURL}>
									{palette => (
										<div
											className={styles.overlay}
											style={{ backgroundColor: palette.vibrant }}
										/>
									)}
								</Palette>
								<h2 className={styles.title} key={project.title}>
									{project.title}
								</h2>
								<span className={styles.service} key={project.service}>
									{project.service}
								</span>
								
							</Link>
						</div>
					</div>
				))}
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/ProjectListing/ProjectListing.jsx